// extracted by mini-css-extract-plugin
module.exports = {"link-title":"link-title__xHcil","link-title-chevron":"link-title-chevron__oqnui","hover":"hover__rdKzW"};